import jsPDF from 'jspdf'
import 'jspdf-autotable'
import DatePicker from 'react-datepicker'
import Select from 'react-select'
import axios from 'axios'
import download from 'downloadjs'
import { Button, OverlayTrigger, Tooltip, Dropdown } from 'react-bootstrap'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useMemo, useRef, useState } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import { toggleChecked, setReceiverId } from 'src/store/balanceShow/actions'
import { resetFormFields } from 'src/store/formReset/actions'; // Adjust the path to your actions file
import { getParty, getUsers, getPartyLedgerList } from '../../core/_requests'
import { redirectPartyList } from 'src/store/commonlist/actions'
import { KTSVG, useDebounce } from '../../../../../../../_metronic/helpers'
import { useQueryRequest } from '../../core/QueryRequestProvider'
import { useNavigate } from 'react-router-dom';

import {
  useQueryResponse,
  useQueryResponseDataLedger,
  useQueryResponseDataMessage,
} from '../../core/QueryResponseProvider'
import { configuration } from 'src/configuration'
import { SET_CHECKED_FALSE } from 'src/store/balanceShow/types';
import clsx from 'clsx'
import moment from 'moment'
const API_URL = configuration.apiUrl

const options = [
  { value: 'option 1', label: 'Option 1' },
  { value: 'option 2', label: 'Option 2' },
  { value: 'option 3', label: 'Option 3' },
  { value: 'option 4', label: 'Option 4' },
  { value: 'option 5', label: 'Option 5' },
]

const PartyLedgerListSearchComponent = ({
  senderId,
  setSenderId,
  receiverId,
  partyId, // receiverId → partyId
  setPartyId, // setReceiverId → setPartyId
  setReceiverId,
  alterNative,
  setAlterNative,
  setApiTotals,
  setIsCheckboxChecked,
  setSelectedRows,
}: any) => {

  const { state, updateState }: any = useQueryRequest()
  const [searchTerm, setSearchTerm] = useState<string>('')
  const [partyLedgerList, setPartyLedgerList] = useState<any>([])
  const [fetchedPartyLedger, setFetchedPartyLedger] = useState<any>([])
  const [partyLedgerDetail, setPartyLedgerDetail] = useState<any>(null)
  const [ShowMondayFinalModal, setShowMondayFinalModal] = useState<any>(false)
  const [financialSummary, setFinancialSummary] = useState<any>(null) // State for API response
  const [isLoadingFinancialSummary, setIsLoadingFinancialSummary] = useState(false) // Loading state
  const [fromDate, setFromDate] = useState<any>(moment())
  const [toDate, setToDate] = useState<any>(moment())
  const {response, refetch } = useQueryResponse()
  const PartyLedgerMessage = useQueryResponseDataMessage()
  const debouncedSearchTerm = useDebounce(searchTerm, 150)
  const [selectedRadio, setSelectedRadio] = useState<any>(2)
  const PartyLedgers = useQueryResponseDataLedger()
  const redirectList = useSelector((state: any) => state.commonList.redirectList)
  const [showAllTallyModal, setShowAllTallyModal] = useState(false)
  const isLoading = false
  const [isSenderMenuOpen, setIsSenderMenuOpen] = useState(true)
  const navigate = useNavigate();

  // const [newShow,setNewShow] = useState(false)
  // Use Redux for showBalance
  // useEffect(() => {
    
  // }, [])
  const dispatch = useDispatch()
  const showBalance = useSelector((state: any) => state.toggle.isChecked)
  useEffect(() => {
    // Reset Redux toggle when this component mounts
    dispatch({ type: SET_CHECKED_FALSE });
  }, [dispatch]);
  // Sync newShow with Redux showBalance

  const receiverid = useSelector((state: any) => state.toggle.receiverId)
  // console.log('Hellllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllllll', partyId)

  const cityList = useSelector((state: any) => state.commonList.cityList)
  const isAdmin = cityList?.roleInfo?.id === 1 || cityList?.roleInfo?.id === 2
  const isGeneralExportPermission =
    cityList?.roleInfo?.id === 3 && cityList?.userPermissionInfo[0]?.general_report_export === true
  const [isExportLoading, setExportLoading] = useState(false)
  const [isExcelLoading, setExcelLoading] = useState(false)

  const inputRef = useRef<any>(null)
  // useEffect(() => {
    
  // }, [])
  
  useEffect(() => {
    if (inputRef.current && alterNative === 1) {
      inputRef.current.focus()
      inputRef.current.openMenu();
    }
  }, [alterNative])
  // useEffect(() => {
  //   if (partyId && inputRef.current) {
  //     inputRef.current.blur(); // This will close the dropdown
  //   }
  // }, [partyId])
  // useEffect(() => {
  //   if (partyId && inputRef.current) {
  //     inputRef.current.focus(); // Optional
  //     setTimeout(() => {
  //       inputRef.current.blur(); // This will close after a short delay
  //     }, 200)
  //   }
  // }, [partyId])
  const handleToggleBalance = () => {
    dispatch(toggleChecked())
  }

  const exportPDF = async () => {
    try {
      setExportLoading(true)
      const filteredFilters = Object.fromEntries(
        Object.entries(state?.filter || {}).filter(
          ([key]) => !['filter[limit]', 'filter[offset]'].includes(key)
        )
      )
      let responseData = await axios.get(`${API_URL}/party/branchLedger/${partyLedgerDetail}`, {
        params: {
          ...filteredFilters,
          'filter[exportPdf]': true,
        },
        responseType: 'blob',
      })

      const selectedPartyLedger = partyLedgerList.find(
        (partyLedger: any) => partyLedger.value === partyLedgerDetail
      )
      const partyLedgerName = selectedPartyLedger ? selectedPartyLedger.label : 'PartyLedger'

      const blob = new Blob([responseData.data], { type: 'application/pdf' })
      const url = window.URL.createObjectURL(blob)

      const filename = `${partyLedgerName}.pdf`
      const link = document.createElement('a')
      link.href = url
      link.download = filename
      link.click()

      window.URL.revokeObjectURL(url)
      setExportLoading(false)
    } catch (err) {
      setExportLoading(false)
      console.error(err)
    }
  }

  const exportExcel = async () => {
    setExcelLoading(true)
    try {
      // Same filter logic as PDF
      const filteredFilters = Object.fromEntries(
        Object.entries(state?.filter || {}).filter(
          ([key]) => !['filter[limit]', 'filter[offset]'].includes(key)
        )
      )
  
      const response = await axios.get(`${API_URL}/party/branchLedger/${partyLedgerDetail}`, {
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        params: {
          ...filteredFilters,
          'filter[exportExcel]': true, // matching export flag like PDF
        },
        responseType: 'blob',
      })
  
      const selectedPartyLedger = partyLedgerList.find(
        (partyLedger: any) => partyLedger.value === partyLedgerDetail
      )
      const partyLedgerName = selectedPartyLedger ? selectedPartyLedger.label : 'PartyLedger'
  
      const contentType = response.headers['content-type']
      download(response.data, `${partyLedgerName}.xlsx`, contentType)
  
      setExcelLoading(false)
    } catch (error) {
      setExcelLoading(false)
      console.error('Error downloading the file:', error)
    }
  }
  

  const filteredSenderPartyLedgerList = useMemo(() => {
    return partyLedgerList.filter((x: any) => x.value !== receiverId)
  }, [receiverId, partyLedgerList])

  const fetchPartyLedgerList = async () => {
    try {
      let data = (await getParty()) as any
      if (data.status === 200 || data.data.length > 0) {
        const mappedPartyLedger = data.data.map((x: any) => ({
          label: x.nameCode,
          value: x.partyId,
          party_code: x.party_code,
          ...x,
        }))

        setPartyLedgerList(mappedPartyLedger)
        setFetchedPartyLedger(mappedPartyLedger)

        // Handle party selection from Redux
        if (receiverid) {
          const matchedParty = mappedPartyLedger.find(
            (party: any) => party.party_code === receiverid
          )
          // console.log('matchedParty===============================+>>>>>>>>>>>>>>>', matchedParty);
          if (matchedParty) {
            setPartyLedgerDetail(matchedParty.value)
            await updateState({
              search: '',
              page: 1,
              perPage: 25,
              orderBy: 'created_date ASC',
              ['filter[fromdate]']:  fromDate.format('YYYY-MM-DD'),
              ['filter[todate]']: toDate.format('YYYY-MM-DD'),
              ['filter[limit]']: 100,
              ['filter[offset]']: 0,
              uuid: matchedParty.value,
            })
            setAlterNative(2)
            refetch()
          }
        }
        return mappedPartyLedger
      }
    } catch (err: any) {
      console.error('Something went wrong:', err?.message || 'Unknown error')
      return []
    }
  }

  // useEffect(() => {
  //   fetchPartyLedgerList();
  //   console.log("first loading useEffect");

  // }, []);
  // Simplified useEffect structure
  useEffect(() => {
    fetchPartyLedgerList()
  }, [])

  // Handle receiverid changes
  useEffect(() => {
    if(partyId){
      // console.log('Party ID:--------ss---------------------------------------...................', partyId)
      const fetchPartyDetails = async () => {
        if (partyId && partyLedgerList.length > 0) {
      // console.log('Party ID:-----------------------------------------------...................', partyId)
        
          // console.log('Party ID:-----------------------------------------------...................', partyId)
          const matchedParty = partyLedgerList.find((party: any) => party.partyId == partyId);
          if (partyId && matchedParty) {
            // console.log('Matched Party:assssssssssssssssssssssssssssss',partyId, matchedParty);
            if (partyId) {
              setPartyLedgerDetail(matchedParty.value);

              await updateState({
                search: '',
                page: 1,
                perPage: 25,
                orderBy: 'created_date ASC',
                ['filter[fromdate]']: fromDate.format('YYYY-MM-DD'),
                ['filter[todate]']: toDate.format('YYYY-MM-DD'),
                ['filter[limit]']: 100,
                ['filter[offset]']: 0,
                uuid: partyId,
              })
              refetch()
  
            }
          }
        }
      };
  
      fetchPartyDetails(); // Call the async function
    }

  }, [partyId, partyLedgerList]);

  useEffect(() => {
    if (!fromDate || !toDate || !partyLedgerDetail) return

    const updateFilters = async () => {
      // console.log('Updating state with filters:', {
      //   fromDate: fromDate.toISOString().split('T')[0],
      //   toDate: toDate.toISOString().split('T')[0],
      //   uuid: partyLedgerDetail,
      // })

      await updateState({
        filter: {
          orderBy: 'created_date ASC',
          ['filter[fromdate]']: fromDate.format('YYYY-MM-DD'),
          ['filter[todate]']: toDate.format('YYYY-MM-DD'),
          ['filter[limit]']: 100,
          ['filter[offset]']: 0,
        },
        uuid: partyLedgerDetail,
      })
    }
    updateFilters()
  }, [fromDate, toDate, partyLedgerDetail])

  useEffect(() => {
    const resp: any = response as any;
    if (resp && resp.responseData) {
      const { total_Credit = 0, total_Debit = 0, total_Balance = 0 } = resp.responseData;
      setApiTotals({
        total_Credit,
        total_Debit,
        total_Balance,
      });
    }
  }, [response, setApiTotals]);

  const handleSubmit = async ({ cId, radioButton }: any) => {
    // Clear any existing selections first
    dispatch({ type: SET_CHECKED_FALSE });
    dispatch({ type: 'SET_RECEIVER_ID', payload: null });
    
    await updateState({
      filter: {
        orderBy: 'created_date ASC',
        ['filter[fromdate]']: fromDate.format('YYYY-MM-DD'),
        ['filter[todate]']: toDate.format('YYYY-MM-DD'),
        ['filter[limit]']: 100,
        ['filter[offset]']: 0,
      },
      uuid: cId,
    })
    setPartyLedgerDetail(cId)
    setSelectedRadio(radioButton)
    await refetch()
  }

  const handleRadioChange = (value: number) => {
    setSelectedRadio(value)
    handleSubmit({ cId: partyLedgerDetail, radioButton: value })
  }

  const handleReset = async () => {
    // Synchronous dispatches and state updates
    dispatch({ type: SET_CHECKED_FALSE });
    dispatch({ type: 'SET_RECEIVER_ID', payload: null });
    dispatch(resetFormFields()); // Use plain object instead of setReceiverId
    // setSenderId(null); // Do NOT reset senderId
    setReceiverId(null);
    setFromDate(moment());
    setToDate(moment());
    // setPartyLedgerDetail(null); // Do NOT reset partyLedgerDetail
    // setAlterNative(1);
    setSelectedRadio(2);
    setSearchTerm('');
    // setPartyId(null); // Do NOT reset partyId
    setIsCheckboxChecked(false);
    setSelectedRows([]); // Clear table selection on reset
    // inputRef.current.openMenu();
    // Async operations
    await updateState({
      search: '',
      page: 1,
      perPage: 25,
      filter: {
        fromDate: fromDate.format('YYYY-MM-DD'),
        toDate: toDate.format('YYYY-MM-DD'),
        radioValue: 2,
      },

      uuid: '',
    });
    refetch();
    await fetchPartyLedgerList();
  };

  const customSelectStyles = {
    control: (provided: any) => ({
      ...provided,
      borderColor: '#E4E6EF',
      borderWidth: '2px',
      borderRadius: '0.475rem',
      cursor: 'pointer',
      minHeight: '54.25px',
      boxShadow: 'none',
      fontSize: '16px',
      '&:hover': {
        borderColor: '#cdcdde',
      },
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      lineHeight: '1.5',
    }),
    input: (provided: any) => ({
      ...provided,
      margin: '0',
    }),
    indicatorSeparator: () => ({
      display: 'none',
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
    }),
    option: (provided: any) => ({
      ...provided,
      cursor: 'pointer', // Optional: adds pointer to dropdown options too
    }),
  }
  // console.log('stste value', state)

  return (
    <>
      <div className='row'>
        <div className='col-md-12 col-lg-4 d-flex align-items-center'>
          <h1 className='fs-3 me-3 text-nowrap'>Party Ledger</h1>
          <div
                  className="btn btn-icon btn-shadow-lg  bg-primary text-white position-absolute start-100 translate-middle d-flex align-items-center justify-content-center border border-light"
                  style={{ zIndex: 99, top: "42px", marginLeft: "-34px" ,width: "34px",
                    height: "32px"}}
                  role="button"
                  aria-label="Go back to previous page"
                  tabIndex={0}
                  data-tooltip="Back"
                  onClick={() => navigate(-1)}
                >
                  <KTSVG path="/media/icons/duotune/arrows/arr025.svg" className="svg-icon-4 text-white" />
                </div>
          <Select
            options={filteredSenderPartyLedgerList}
            className='w-100'
            placeholder='Select party'
            styles={customSelectStyles}
            ref={inputRef}
            autoFocus
            blurInputOnSelect={true}
            onChange={(selectedOption: any) => {
              if (selectedOption && selectedOption.value) {
                handleSubmit({ cId: selectedOption.value, radioButton: 2 })
                dispatch(redirectPartyList(selectedOption.value))
                setSenderId(selectedOption.value)
                setAlterNative(2)
              }
            }}
            value={
              filteredSenderPartyLedgerList.find(
                (option: any) => option.value === partyLedgerDetail
              ) || null
            }
            filterOption={(option, inputValue) => {
              if (!inputValue) return true;
              return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
            }}
            menuPlacement="auto"
            menuPosition="absolute"
            onKeyDown={(e) => {
              if (e.key === 'Tab') {
                e.preventDefault();
                setAlterNative(2);
                // Close the current dropdown
                if (inputRef.current) {
                  inputRef.current.blur();
                }
                // Dispatch action to set receiverId to null to ensure AddMessageComponent's dropdown is ready
                dispatch({ type: 'SET_RECEIVER_ID', payload: null });
              }
            }}
          />
        </div>
        <div className='col-md-6 col-lg-4'>
          <div className='d-flex align-items-center'>
            <div className='position-relative w-100'>
              <DatePicker
                selected={fromDate.toDate()}
                onChange={(date: Date) => setFromDate(moment(date))}
                selectsStart
                startDate={fromDate.toDate()}
                endDate={toDate.toDate()}
                dateFormat='dd-MM-yyyy'
                className='form-control date-picker'
                showMonthDropdown // Added
                showYearDropdown // Added
                dropdownMode='select' // Added
                placeholderText='From Date'
                maxDate={new Date()}
                onKeyDown={(event: any) => event.preventDefault()}
              // style={{ cursor: 'pointer' }}
              />
              <i
                className='fa fa-calendar position-absolute'
                style={{
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#555',
                }}
              ></i>
            </div>
            <div className='position-relative w-100 ms-2'>
              <DatePicker
                selected={toDate.toDate()}
                onChange={(date: Date) => setToDate(moment(date))}
                selectsEnd
                startDate={fromDate.toDate()}
                endDate={toDate.toDate()}
                minDate={fromDate.toDate()}
                dateFormat='dd-MM-yyyy'
                className='form-control ms-2 date-picker'
                placeholderText='To Date'
                showMonthDropdown // Added
                showYearDropdown // Added
                dropdownMode='select' // Added
                maxDate={new Date()}
                style={{ cursor: 'pointer' }}
                onKeyDown={(event: any) => event.preventDefault()}
              />
              <i
                className='fa fa-calendar position-absolute'
                style={{
                  right: '10px',
                  top: '50%',
                  transform: 'translateY(-50%)',
                  pointerEvents: 'none',
                  color: '#555',
                }}
              ></i>
            </div>
          </div>
        </div>
        <div className="col-md-6 col-lg-4">
          <div className="d-flex justify-content-end align-items-center h-100">
            {state.uuid && (
              <div className="d-flex align-items-center me-4">
                <div className="dropdown me-2">
                  <button
                    type="button"
                    className="btn btn-danger fw-bold px-4 h-50px d-flex align-items-center"
                    // style={{ backgroundColor: '#ffcccc', color: '#a94442', border: '1px solid #f5c6cb' }}
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                    disabled={isExportLoading || isExcelLoading}
                  >
                    {isExportLoading || isExcelLoading ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm me-2"
                          role="status"
                          aria-hidden="true"
                        ></span>
                        Exporting...
                      </>
                    ) : (
                      <>
                        <span className='svg-icon svg-icon-2'>
                                  <KTSVG path='/media/icons/duotune/files/fil021.svg' className='svg-icon-1' />
                                </span>
                        EXPORT
                      </>
                    )}
                  </button>
                  <ul className="dropdown-menu">
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={exportPDF}
                        disabled={isExportLoading}
                      >
                        <i className="fa-solid fa-file-pdf me-2"></i>PDF
                      </button>
                    </li>
                    <li>
                      <button
                        className="dropdown-item"
                        onClick={exportExcel}
                        disabled={isExcelLoading}
                      >
                        <i className="fa-solid fa-file-excel me-2"></i>Excel
                      </button>
                    </li>
                  </ul>
                </div>
                <button
                type="button"
                className="btn btn-light btn-active-light-primary fw-bold px-6"
                onClick={handleReset}
                tabIndex={5}
              >
                Reset
              </button>
              {/* <input
              type="checkbox"
              // checked={allDataRowsSelected}
              // onChange={handleSelectAll}
              style={{cursor: 'pointer'}}
            /> */}
              </div>
            )}
            <div className="d-flex justify-content-end align-items-center">
              <OverlayTrigger
    placement='bottom'
    overlay={<Tooltip>{showBalance ? 'Hide Balance' : 'Show Balance'}</Tooltip>}
              >
    <div className='d-flex justify-content-end py-4'>
      <div className='form-check form-switch' style={{ marginRight: '35px' }}> {/* Shift left */}
                  <input
          className='form-check-input'
          type='checkbox'
          id='showBalanceSwitch'
                    checked={showBalance}
                    onChange={handleToggleBalance}
          style={{ cursor: 'pointer' }}
                  />
      </div>
                </div>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export { PartyLedgerListSearchComponent }
